import React, { useState } from 'react';
import Modal from '@hubins/components/Modal';
import Button from '@hubins/components/Button';
import Input from '@hubins/components/Input';
import { useMiddleman } from '@hubins/middleman';
import ErrorMessage from 'components/ErrorMessage';
import __ from 'localisation';

const EditModal = ({ withdrawalAccount, setWithdrawalAccount, refetch, portfolioUuid }) => {
  const middleman = useMiddleman();

  const [accountNumber, setAccountNumber] = useState(withdrawalAccount.account_number);
  const [bicCode, setBicCode] = useState(withdrawalAccount.bic_code);
  const [uuid, setUuid] = useState(withdrawalAccount.uuid);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    setLoading(true);
    setError(null);
    try {
      e.preventDefault();
      const submitFunc = uuid ? middleman.put : middleman.post;
      const url = `/ql/crm/withdrawal-accounts/${portfolioUuid}${uuid ? `/${uuid}` : ''}`;
      const body = {
        accountNumber: accountNumber,
        bicCode: bicCode,
      };
      await submitFunc(url, body);
      refetch();
      setWithdrawalAccount(null);
    } catch (error) {
      setError(error.message);
    }
    setLoading(false);
  }

  return (
    <Modal open={true} callback={setWithdrawalAccount} closeButton={true} shouldCloseOnOverlayClick={true}>
      <form onSubmit={handleSubmit} className='s-top-l'>
        <Input label={__('account_number')} value={accountNumber} callback={setAccountNumber} className="input-max-width" />
        <Input label={__('bic_code')} value={bicCode} callback={setBicCode} className="input-max-width" />
        <Button type="submit" disabled={loading} loading={loading} className="s-top-m">
          {__('save')}
        </Button>
        <ErrorMessage text={error} showError={!!error} />
      </form>
    </Modal>
  );
};

export default EditModal;